/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetIdInfoRequest as AgentApiContractGetIdInfoRequest } from '../../models/AgentApi/Contract/get-id-info-request';
import { GetIdInfoResponse as AgentApiContractGetIdInfoResponse } from '../../models/AgentApi/Contract/get-id-info-response';

export interface ApiAgentGetIdInfoPost$Params {

/**
 * *	language code
 */
  lang?: string;
      body?: AgentApiContractGetIdInfoRequest
}

export function apiAgentGetIdInfoPost(http: HttpClient, rootUrl: string, params?: ApiAgentGetIdInfoPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractGetIdInfoResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAgentGetIdInfoPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractGetIdInfoResponse>;
    })
  );
}

apiAgentGetIdInfoPost.PATH = '/api/Agent/GetIdInfo';
